import { Router, ActivatedRoute, Params } from '@angular/router';
import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
  ViewChildren,
  ChangeDetectorRef,
} from '@angular/core';

import { PostcodeWeightService } from '../../services/postcode-weight.service';
import { ConfirmationService } from 'primeng';
import { UserService } from '../../services';

@Component({
  selector: 'manage-weight',
  templateUrl: './manage-weight.component.html',
})
export class ManageWeightComponent implements OnInit {
  public backTo: string;
  isPricingAdmin: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private postcodeWeightService: PostcodeWeightService,
    private changeDetector: ChangeDetectorRef,
    private confirmationService: ConfirmationService,
    private userService: UserService,
  ) {}

  async ngOnInit() {
    this.isPricingAdmin = await this.userService.isUserInRole('PricingAdmin');
  }
}
